import GlobalE from './GlobalE';

export default GlobalE;
